import { useTranslation } from 'react-i18next'

import { OpportunityForm as F, OpportunityType } from '@percent/domain/volunteering'
import { goodstackPalette } from '@percent/cause-dashboard/theme/theme'
import dayjs from 'dayjs'

export function DateFields(
  props: Omit<
    F.DateFieldsProps,
    | 'opportunityType'
    | 'dateLabel'
    | 'startTimeLabel'
    | 'endTimeLabel'
    | 'startDateLabel'
    | 'endDateLabel'
    | 'timeZoneMessage'
    | 'colorTheme'
    | 'formatDate'
    | 'datePlaceholder'
  >
) {
  const { t } = useTranslation()

  return (
    <F.DateFields
      {...props}
      opportunityType={OpportunityType.Event}
      formatDate={d => dayjs(d).format('MMMM D, YYYY')}
      datePlaceholder={t('volunteering.opportunity.form.common.detailsSection.dateField.placeholder', {
        date: dayjs().add(1, 'year').startOf('year').format('MMMM D, YYYY')
      })}
      colorTheme={goodstackPalette}
      dateLabel={t('volunteering.opportunity.form.common.detailsSection.dateField.label')}
      startDateLabel={t('volunteering.opportunity.form.common.detailsSection.dateField.startDateLabel')}
      endDateLabel={t('volunteering.opportunity.form.common.detailsSection.dateField.endDateLabel')}
      startTimeLabel={t('volunteering.opportunity.form.common.detailsSection.dateField.startTimeLabel')}
      endTimeLabel={t('volunteering.opportunity.form.common.detailsSection.dateField.endTimeLabel')}
    />
  )
}
